<div>
  <ng-container i18n>Builder form component</ng-container>
  <button type="button" (click)="preview()" i18n>Preview</button>
</div>
<eas-builder-group *ngIf="form?.group" [group]="form.group"></eas-builder-group>

<div i18n>States</div>
<eas-builder-states *ngIf="form?.states" [group]="form.group" [states]="form.states" [transitions]="form.transitions"></eas-builder-states>

<div i18n>Initial state</div>
<eas-builder-initial-state *ngIf="form?.initial" [initialState]="form.initial" [states]="form.states"></eas-builder-initial-state>

<div i18n>Transitions</div>
<eas-builder-transitions *ngIf="form?.transitions" [transitions]="form.transitions" [states]="form.states"></eas-builder-transitions>
